import { SimpleSelect } from '@/UIComponents2/Select/SimpleSelect'
import { useMemo } from 'react'

function getTimeZoneOffset(timeZone: string) {
    // Format the date for the given time zone
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone,
        timeZoneName: 'longOffset',
    })

    // Format and extract the offset
    const parts = formatter.formatToParts(new Date())
    const offsetPart = parts.find((part) => part.type === 'timeZoneName')

    if (offsetPart?.value === 'GMT') {
        return 'GMT+00:00'
    }

    return offsetPart?.value || '+00:00'
}

// @ts-ignore
const tzOptions = Intl.supportedValuesOf('timeZone')
    .map((code: string) => {
        const offset = getTimeZoneOffset(code)

        return {
            label: code.replaceAll('_', ' '),
            offset,
            code,
        }
    })
    .sort((a: any, b: any) => {
        const a2 = a.offset + a.code
        const b2 = b.offset + b.code
        return a2.localeCompare(b2)
    })

const tzSelectItems = tzOptions.map((data) => {
    return {
        label: `(${data.offset}) ${data.label}`,
        value: data.code,
    }
})

export default function TzSelector({
    value,
    disabled = false,
    onChange,
}: {
    value: string
    disabled?: boolean
    onChange: (value: string) => void
}) {
    const defaultValue = useMemo(() => tzOptions.find((a: any) => a.code === value), [value])

    return (
        <div className="w-full relative">
            <SimpleSelect
                items={tzSelectItems}
                value={defaultValue?.code}
                onChange={(value) => value && onChange(value)}
            ></SimpleSelect>
        </div>
    )
}
